import type { ReactNode } from 'react';

export const symbol_movie_speaker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-220v-368 96-75 347Zm0 60q-24 0-42-18t-18-42v-520q0-24 18-42t42-18l58 119q8 15 22 24t31 9q32 0 49-27.5t3-56.5l-33-68h89l58 119q8 15 22 24t31 9q32 0 49-27.5t3-56.5l-33-68h89l58 119q8 15 22 24t31 9q32 0 49-27.5t3-56.5l-33-68h112q24 0 42 18t18 42v152H140v368h170q13 0 21.5 8.5T340-190q0 13-8.5 21.5T310-160H140Zm290-27q-13 0-21.5-8.5T400-217v-84q0-13 8.5-21.5T430-331h89l83-83q7-7 16.5-3.5T628-404v290q0 10-9.5 13.5T602-104l-83-83h-89Zm491-72q0 73-40.5 134T772-37q-11 5-22-1.5T736-57q-3-12 3.5-23T757-96q48-22 75.5-65.5T860-259q0-54-27.5-97.5T757-422q-11-5-17.5-16t-3.5-23q3-12 14.5-18.5T773-481q69 26 108.5 87.5T921-259Zm-171-56q10 11 15 25.5t5 30.5q0 16-5 30.5T750-203q-5 7-13.5 3.5T728-213v-92q0-9 8-12.5t14 2.5Z"
		/>
	</svg>
);
